import { Link } from 'react-router-dom';
import { BarChart3, Bell, CalendarClock, CheckCircle2, Eye, MailPlus, Send } from 'lucide-react';
import { datumLang } from '../../lib/mailBuilder/vorlagen';
import { formatDateTime } from '../../lib/format';
import type { Stand } from './modell';

export type Ergebnis =
  | { art: 'eingereicht' }
  | { art: 'geplant'; wann: string }
  | { art: 'versendet' };

/** Nach dem Einreichen oder Versenden: Was passiert jetzt — und wer ist dran? */
export function Fertig({ stand, ergebnis, onNochEine }: { stand: Stand; ergebnis: Ergebnis; onNochEine: () => void }) {
  const aktionen = (
    <div className="fertig-aktionen">
      <Link to="/meine-mails" className="btn btn-primary">Zu meinen Mails</Link>
      <button type="button" className="btn btn-secondary" onClick={onNochEine}><MailPlus size={16} aria-hidden="true" /> Noch eine Mail vorbereiten</button>
    </div>
  );

  if (ergebnis.art !== 'eingereicht') {
    return (
      <div className="assistent-karte fertig-karte">
        <span className="fertig-symbol" aria-hidden="true"><CheckCircle2 size={40} /></span>
        <h2>{ergebnis.art === 'geplant' ? 'Eingeplant!' : 'Unterwegs!'}</h2>
        <p className="fertig-titel">
          „{stand.betreff}" {ergebnis.art === 'geplant' ? <>geht am <strong>{formatDateTime(ergebnis.wann)}</strong> raus.</> : 'wird gerade verschickt.'}
        </p>
        <ul className="fertig-liste">
          <li><Send size={18} aria-hidden="true" /><span>Brevo verschickt die Mail an die gewählten Gruppen — nur an Kontakte mit Einwilligung, die internen Verteiler bekommen sie in Kopie.</span></li>
          <li className="ausblick"><Eye size={18} aria-hidden="true" /><span>Im Verlauf der Mail steht, dass Du sie ohne Freigabe verschickt hast.</span></li>
          <li className="ausblick"><BarChart3 size={18} aria-hidden="true" /><span>Unter „Meine Mails" siehst Du nach dem Versand, wie viele sie geöffnet haben.</span></li>
        </ul>
        {aktionen}
      </div>
    );
  }

  return (
    <div className="assistent-karte fertig-karte">
      <span className="fertig-symbol" aria-hidden="true"><CheckCircle2 size={40} /></span>
      <h2>Eingereicht!</h2>
      <p className="fertig-titel">„{stand.betreff}" liegt jetzt bei der Redaktion.</p>
      <ul className="fertig-liste">
        <li><Send size={18} aria-hidden="true" /><span>Die Redaktion hat gerade eine Mail mit Deiner Einreichung bekommen.</span></li>
        <li className="ausblick"><Eye size={18} aria-hidden="true" /><span>Sie prüft Sprache, Form und Empfänger — und fragt nach, wenn etwas unklar ist.</span></li>
        <li className="ausblick"><Bell size={18} aria-hidden="true" /><span>Bei Freigabe oder Rückfrage bekommst Du eine E-Mail. Den Stand siehst Du jederzeit unter „Meine Mails".</span></li>
        <li className="ausblick">
          <CalendarClock size={18} aria-hidden="true" />
          <span>Nach der Freigabe geht die Mail {stand.wunschDatum ? <>am <strong>{datumLang(stand.wunschDatum)}</strong> um {stand.wunschZeit} Uhr</> : 'zum Wunschtermin'} raus{stand.eilt ? ' — als eilig markiert' : ''}.</span>
        </li>
      </ul>
      {aktionen}
    </div>
  );
}
